// Dictionnaires de langues : ajouter une langue = ajouter une entrée dans DICTS.
const fr = {
  "status.trial": "Essai",
  "status.active": "Actif",
  "status.suspended": "Suspendu",
  "status.expired": "Expiré",
  "status.invited": "Invité",
  "status.disabled": "Désactivé",
  "domain.pending": "En attente",
  "domain.verified": "Vérifié",
  "domain.failed": "Échec",
  "https.not_configured": "Non configuré",
  "https.active": "Certificat actif",
  "https.invalid": "Certificat invalide",
  "https.unavailable": "Indisponible",
  "module.available": "Disponible",
  "module.beta": "Bêta",
  "module.disabled": "Désactivé",
  "role.super_admin": "Super administrateur",
  "role.platform_admin": "Administrateur plateforme",
  "result.success": "Succès",
  "result.failure": "Échec",
};

const DICTS = { fr };
let current = "fr";

export const setLanguage = (lang) => {
  if (DICTS[lang]) current = lang;
};

export const t = (key, fallback) => DICTS[current][key] ?? fallback ?? key;

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export const fmtDateTime = (v) =>
  v ? new Date(v).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
